import { render, staticRenderFns } from "./notification-sites.vue?vue&type=template&id=5d52f2ea&"
import script from "./notification-sites.vue?vue&type=script&lang=js&"
export * from "./notification-sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports